import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { ReactComponent as QrCodeIcon } from "./QrCodeIcon.svg";
import { ReactComponent as SmsIcon } from "./SmsIcon.svg";
import { enableSmsMultifactorAuthentication } from "@/App/utils/featureFlags";
import styled from "styled-components";

export interface SelectMultifactorAuthenticationFormData {
  readonly multifactorAuthenticationMode: "sms" | "totp";
}

interface SelectMultifactorAuthenticationFormProps {
  readonly onSubmit: (formData: SelectMultifactorAuthenticationFormData) => Promise<void>;
}

const SelectMultifactorTypeButton = styled.div`
  border: solid 1px #aebfcc;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.primary_button_color}0D !important;
  }
`;

export const SelectMultifactorAuthenticationForm: FC<SelectMultifactorAuthenticationFormProps> = ({ onSubmit }) => {
  const { t: translate } = useTranslation();
  const { isCompressed } = useResponsive({
    isCompressed: {
      mobile: true,
      desktop: enableSmsMultifactorAuthentication() ? false : true,
    },
  });

  const onSelectText = useCallback(() => {
    onSubmit({
      multifactorAuthenticationMode: "sms",
    });
  }, []);

  const onSelectTotp = useCallback(() => {
    onSubmit({
      multifactorAuthenticationMode: "totp",
    });
  }, []);

  return (
    <Grid>
      {enableSmsMultifactorAuthentication() && (
        <Grid.Span columns={isCompressed ? 12 : 6}>
          <SelectMultifactorTypeButton onClick={onSelectText}>
            <Shelf>
              <span>
                <SmsIcon />
              </span>
              <Stack spacing="none">
                <Semibold>{translate("MULTIFACTOR_AUTHENTICATION.selectMultifactorAuthenticationForm.textMessage")}</Semibold>
                <Body>{translate("MULTIFACTOR_AUTHENTICATION.selectMultifactorAuthenticationForm.receiveTextMessage")}</Body>
              </Stack>
              <Shelf.Spacer />
            </Shelf>
          </SelectMultifactorTypeButton>
        </Grid.Span>
      )}

      <Grid.Span columns={isCompressed ? 12 : 6}>
        <SelectMultifactorTypeButton onClick={onSelectTotp}>
          <Shelf>
            <span>
              <QrCodeIcon />
            </span>
            <Stack spacing="none">
              <Semibold>{translate("MULTIFACTOR_AUTHENTICATION.selectMultifactorAuthenticationForm.authenticatorApp")}</Semibold>
              <Body>{translate("MULTIFACTOR_AUTHENTICATION.selectMultifactorAuthenticationForm.getCodeFromAuthenticatorApp")}</Body>
            </Stack>
            <Shelf.Spacer />
          </Shelf>
        </SelectMultifactorTypeButton>
      </Grid.Span>
    </Grid>
  );
};
